// extracted by mini-css-extract-plugin
export default {"songDynasty":"song-dynasty_songDynasty__JB3wd","selectedDynasty":"song-dynasty_selectedDynasty__8M0qv"};